import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.brief-product-links': {
    flexDirection: 'column',
    gap: theme.space[2],
    paddingLeft: theme.space[3],
  },
  '.brief-product-links': {
    '&__link-icon': {
      marginLeft: theme.space[2],
    },
    '&__link': {
      display: 'flex',
      alignItems: 'center',
      color: COLORS.PRIMARY500,
    },
    '&__link:hover': {
      textDecoration: 'underline',
    },
    '&__link:before': {
      content: '""',
      display: 'block',
      width: '3px',
      height: '3px',
      borderRadius: '50%',
      backgroundColor: COLORS.BLACK,
      marginRight: theme.space[3],
    },
  },
});
